import { Component, inject } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import * as BackCounterRequestActions from "store/back-counter/back-counter.actions";

@Component({
  selector: "cancel-bct-request-modal-modal",
  templateUrl: "./cancel-bct-request-modal.component.html",
})
export class CancelBctRequestModalComponent {
  activeModal = inject(NgbActiveModal);
  store = inject(Store);

  dismiss() {
    this.activeModal.close(false);
  }

  confirm() {
    this.store.dispatch(BackCounterRequestActions.changeLoading({ loading: true }));
    this.store.dispatch(BackCounterRequestActions.setLoading({ requestDetailsLoading: true }));
    this.activeModal.close(true);
  }
}
